module.exports = {
    ACTIVATE_ACCOUNT_ERROR_TOAST_KEY: 'gig_page_perseus.custom_order.activate_your_account',
    ACTIVATE_ACCOUNT_ERROR_DURATION: 3000
};
